import { useTranslation } from 'react-i18next';
import { API_PATCH, API_POST, DBRequest, useConfig } from '../../api/api';
import ExoForm from '../exo/ExoForm';
import { useState } from 'react';
import * as Yup from 'yup';

export const NewSalesLevel = ({
  onUpdate,
  onCreate,
  startData,
  onClose,
  onFeedback,
  salesObjectId,
}) => {
  const { t } = useTranslation();
  const config = useConfig();
  const [isLoading, setIsLoading] = useState(false);

  const fields = [
    {
      label: t('Title'),
      type: 'text',
      key: 'title',
    },
    {
      label: t('Sales level'),
      type: 'customSelect',
      key: 'accessLevel',
      noUnselect: true,
      options: [
        {
          label: (
            <>
              <span className="monospace  mr-1" style={{ fontWeight: 600 }}>
                0
              </span>
              {` - ${t('Start level')}`}
            </>
          ),
          value: 0,
        },
        {
          label: (
            <>
              <span className="monospace  mr-1" style={{ fontWeight: 600 }}>
                1
              </span>
              {` - ${t('Sales level')}`}
            </>
          ),
          value: 1,
        },
        {
          label: (
            <>
              <span className="monospace  mr-1" style={{ fontWeight: 600 }}>
                2
              </span>
              {` - ${t('Sales level')}`}
            </>
          ),
          value: 2,
        },
        {
          label: (
            <>
              <span className="monospace  mr-1" style={{ fontWeight: 600 }}>
                3
              </span>
              {` - ${t('Sales level')}`}
            </>
          ),
          value: 3,
        },
        {
          label: (
            <>
              <span className="monospace  mr-1" style={{ fontWeight: 600 }}>
                4
              </span>
              {` - ${t('Sales level')}`}
            </>
          ),
          value: 4,
        },
      ],
    },
    {
      label: t('Hide the content of this level at higher levels'),
      key: 'hideAtHigherLevels',
      type: 'checkbox',
    },
    {
      label: t('Automatic E-Mail'),
      type: 'expandFields',
      fields: [
        {
          label: t(
            'Should an e-mail be sent automatically when an interested party is assigned to this level?'
          ),
          key: 'sendEmail',
          type: 'checkbox',
        },
        {
          label: t('Subject'),
          key: 'emailSubject',
          type: 'text',
        },
        {
          label: t('Attachments'),
          key: 'emailAttachments',
          type: 'images',
          maxItems: 10,
          maxSizeKB: 5000,
        },
        {
          label: t('Content'),
          key: 'emailContent',
          type: 'richTextEditor',
        },
      ],
    },
  ];

  const validationSchema = Yup.object().shape({
    title: Yup.string().required(t('Is required')),
    accessLevel: Yup.string().required(t('Is required')),
  });

  function handleSubmit(data) {
    const isUpdate = Boolean(data.id);
    DBRequest({
      config,
      path: isUpdate ? `sales-object-levels/${data.id}` : `sales-object-levels`,
      method: isUpdate ? API_PATCH(data) : API_POST({ ...data, salesObjectId }),
      onResponse: isUpdate ? onUpdate : onCreate,
      onLoading: setIsLoading,
    });
  }

  return (
    <ExoForm
      header={startData?.id ? t('Update Sales Level') : t('Create Sales Level')}
      fields={fields}
      startDataCollection={startData}
      onSubmit={handleSubmit}
      onCancle={onClose}
      isLoading={isLoading}
      validationSchema={validationSchema}
      noDifferences
    />
  );
};
